export const ResultCode = {

  SUCCESS: 0,
  ERROR: -1

}
